import React, { useState } from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Modal,
} from '@lockerpm/design';

import formsComponents from "../../../../../../components/forms";
import modalsComponents from "../../../../../../components/modals";

import userServices from '../../../../../../services/user';
import authServices from '../../../../../../services/auth';

import global from "../../../../../../config/global";
import common from "../../../../../../utils/common";

const ChangeMasterPasswordModal = (props) => {
  const { ChangePassword } = formsComponents;
  const { PasswordViolatedModal } = modalsComponents;
  const { t } = useTranslation()
  const {
    visible = false,
    currentPassword,
    onClose = () => { },
  } = props;
  
  const userInfo = useSelector((state) => state.auth.userInfo);
  const [callingAPI, setCallingAPI] = useState(false);
  const [violatedVisible, setViolatedVisible] = useState(false);
  const [policyItem, setPolicyItem] = useState({ violations: [] });

  const handleSave = async (values) => {
    const violations = common.checkMasterPasswordPolicy(values.new_password);
    if (violations.length > 0) {
      setPolicyItem({ violations });
      setViolatedVisible(true);
    } else {
      setCallingAPI(true);
      await userServices.change_password({
        username: userInfo.email,
        password_hint: values.password_hint,
        login_method: 'password',
        password: currentPassword,
        kdf: userInfo.kdf,
        kdf_iterations: userInfo.kdf_iterations,
        kdf_memory: userInfo.kdf_memory,
        kdf_parallelism: userInfo.kdf_parallelism
      }, {
        password: values.new_password,
        kdf: userInfo.kdf,
        kdf_iterations: userInfo.kdf_iterations,
        kdf_memory: userInfo.kdf_memory,
        kdf_parallelism: userInfo.kdf_parallelism
      }).then(async () => {
        global.pushSuccess(t('notification.success.change_master_password.changed'));
        onClose();
        authServices.logout();
      }).catch((error) => {
        global.pushError(error)
      })
      setCallingAPI(false);
    }
  }

  return (
    <>
      <Modal
        title={t('change_password.title')}
        open={visible}
        onCancel={onClose}
        width={360}
        footer={false}
      >
        <ChangePassword
          changing={callingAPI}
          isReset={false}
          onSave={(values) => handleSave(values)}
        />
      </Modal>
      <PasswordViolatedModal
        visible={violatedVisible}
        item={policyItem}
        onClose={() => setViolatedVisible(false)}
      />
    </>
  );
}

export default ChangeMasterPasswordModal;